import i18n from './index';

const PLATFORM_ERROR_CODES = new Set([
  'TEMU_API_ERROR',
  'TIKTOK_API_ERROR',
  'SHEIN_API_ERROR',
]);

/**
 * IPE 业务错误优先按 code 取当前语言。没有对应键时保留后端原文。
 * 平台透传错误保留原文，外面加一层已翻译说明。
 */
export function localizeApiErrorMessage(code, rawMessage) {
  const raw = rawMessage == null ? '' : String(rawMessage);
  const key = String(code || '').trim();
  if (!key) return raw;
  const fullKey = `errors.${key}`;
  if (!i18n.exists(fullKey)) return raw;
  if (PLATFORM_ERROR_CODES.has(key)) {
    return i18n.t(fullKey, { detail: raw });
  }
  return i18n.t(fullKey);
}
